import axios from "axios";
import {
	RestAPI,
	VIPUser,
	IRestResult,
	IAuthRestResponse,
	IErrorRestResponse,
	toaster,
	db,
} from "@/loader";

export abstract class AuthRest {
	public static readonly endpoint: string = "auth";
	private static userID: number = 0;
	private static token: string = "";

	public static get user(): VIPUser | null {
		return db.users.get(AuthRest.userID);
	}

	public static getURL(...urlParts: string[]): string {
		let url: string[] = [RestAPI.url.replace(/\/$/, ""), RestAPI.namespace, ...urlParts];
		return url.join("/");
	}

	private static loggedIn(data: IAuthRestResponse) {
		this.userID = Number.orDefault(data.user.id);
		this.token = String.orDefault(data.token);

		axios.defaults.headers.Authorization = "Bearer " + this.token;

		let item = db.users.insertOrUpdate(data.user);
		toaster.toast({ message: "Bienvenue " + item.first_name });
		return item;
	}

	public static logout() {
		if (this.user) {
			toaster.toast({ message: "Au revoir " + this.user.first_name });
		}

		AuthRest.userID = 0;
		AuthRest.token = "";
		delete axios.defaults.headers;
	}

	public static async validate(): Promise<IRestResult<VIPUser>> {
		return await axios.get<IAuthRestResponse>(AuthRest.getURL()).then(response => {
			let item = this.loggedIn(response.data);
			return <IRestResult<VIPUser>>{ success: true, item };
		}).catch((error: IErrorRestResponse) => {
			this.logout();
			toaster.toast({ message: error.message, variant: "danger", noAutoHide: true });
			return <IRestResult<VIPUser>>{ success: false, error };
		});
	}

	public static async login(data: { username: string, password: string }): Promise<IRestResult<VIPUser>> {
		return await axios.post<IAuthRestResponse>(AuthRest.getURL(), data).then(response => {
			let item = this.loggedIn(response.data);
			return <IRestResult<VIPUser>>{ success: true, item };
		}).catch((error: IErrorRestResponse) => {
			this.logout();
			toaster.toast({ message: error.message, variant: "danger", noAutoHide: true });
			return <IRestResult<VIPUser>>{ success: false, error };
		});
	}

	public static async renew(): Promise<IRestResult<VIPUser>> {
		return await axios.get<IAuthRestResponse>(AuthRest.getURL("renew")).then(response => {
			let item = this.loggedIn(response.data);
			return <IRestResult<VIPUser>>{ success: true, item };
		}).catch((error: IErrorRestResponse) => {
			this.logout();
			toaster.toast({ message: error.message, variant: "danger", noAutoHide: true });
			return <IRestResult<VIPUser>>{ success: false, error };
		});
	}
}
